<script>
  import { afterUpdate } from 'svelte'
  
  import Highcharts, { chart } from "highcharts"
  // import funnel from "highcharts/modules/funnel"
  // import data from "highcharts/modules/data"
  // import exporting from "highcharts/modules/exporting"
  // import exportdata from "highcharts/modules/export-data
  // import accessibility from 'highcharts/modules/accessibility'
  

  import { donutConfigWithData } from './highchartsHelpers'

  // accessibility(Highcharts)

  export let data = undefined
  /**
   * @type {string}
   * This must be set when the graph is placed/implemented
   */
  export let allyDescription = ''

  let chartConfig = {}
  let mountDiv
  let chartRef = undefined

  const legendItemInteraction = (e)=>{
    let clickedIndex = e.target.closest('.highcharts-legend-item').getAttribute('data-index')

    //figure out how to grab the DOM to trigger the hover on
    let selectorString = `path.highcharts-point.highcharts-color-${clickedIndex}`
    let eleToHover = mountDiv.querySelector(selectorString)
    
    // Do the hover
    const mouseoverEvent = new Event('mouseover', { 'bubbles': true })
    eleToHover.dispatchEvent(mouseoverEvent)
  }

  const redrawChart = function() {
    if(data) {
      chartConfig = donutConfigWithData(data, allyDescription)
      chartRef = Highcharts.chart(mountDiv, chartConfig)
    } else {
      console.error('redrawChart() fired, but there is no data yet', chartConfig)
    }
  }

  afterUpdate(()=>{
    setTimeout(() => { 
      redrawChart()
      let legendItems = mountDiv.querySelectorAll('.highcharts-legend-item')
      legendItems.forEach((item, i) => {
        item.addEventListener('mouseover', legendItemInteraction)
        item.setAttribute('data-index', i)
      })
      // chartRef = Highcharts.chart(mountDiv, chartConfig)
    }, 50)
  })
</script>

<figure>
  <p class="highcharts-description visually-hidden">
    { allyDescription }
  </p>
  <div bind:this={ mountDiv }></div>
</figure>

<style>
  div {
    display: flex;
    align-items: center;
  }

  /**
    * https://a11y-guidelines.orange.com/en/articles/accessible-hiding 
    * https://www.a11yproject.com/posts/how-to-hide-content/
  */
  .visually-hidden:not(:focus):not(:active) {
    position: absolute;
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0,0,0,0) !important;
    white-space: nowrap !important;
    border: 0 !important;
  }
</style>
